import { create } from "zustand";
import { it, type Translations } from "./it";
import { en } from "./en";

export type Locale = "it" | "en";

const translations: Record<Locale, Translations> = { it, en };

interface I18nStore {
  locale: Locale;
  t: Translations;
  setLocale: (locale: Locale) => void;
}

function detectLocale(): Locale {
  // Check localStorage first
  if (typeof window !== "undefined") {
    const stored = localStorage.getItem("dalila-locale");
    if (stored === "it" || stored === "en") return stored;
  }

  // Check browser language
  if (typeof navigator !== "undefined") {
    const lang = navigator.language.toLowerCase();
    if (lang.startsWith("it")) return "it";
  }

  return "en";
}

export const useI18n = create<I18nStore>((set) => {
  const initialLocale = detectLocale();
  return {
    locale: initialLocale,
    t: translations[initialLocale],
    setLocale: (locale: Locale) => {
      localStorage.setItem("dalila-locale", locale);
      document.documentElement.lang = locale;
      set({ locale, t: translations[locale] });
    },
  };
});

export { it, en };
export type { Translations };
